
export const mockDataPayment = {
  "easy_payment": {"question": "Был ли Eazy Payment?", "value": false, auto: true},
  // "pricing_region": {"question": "Регион оплаты", "value": "string", "auto": false},
  "package": {"question": "Пакет Курса", "value": 8, "auto": true},
  "amount": {"question": "Цена", "value": 59, "auto": true},
  // "payment_method": {"question": "Метод оплпаты", "value": "string", "auto": true},
  // "currency": {"question": "Валюта", "value": "EUR", "auto": true},
  // "group": {"question": "Группа", "value": "Группа по изучению аксолотлей", "auto": true},
  "course": {"question": "Курс", "value": "Аксолотли и УФ-излучение", "auto": true},
  // "group_type": {"question": "Тип группы", "value": "Микро-группа", "auto": true},
  "monthly_tuition": {"question": "Месячная плата за обучение", "value": 120.99, "auto": false}
}